import { LOGIN_PATH } from 'data/auth/utils'
import React from 'react'
import { goToRoute } from 'utils/history'

import {
  Button,
  CircularProgress,
  createStyles,
  FormControl,
  Input,
  InputLabel,
  Theme,
  Typography,
} from '@mui/material'
import { withStyles, WithStyles } from '@mui/styles'

class RestorePasswordForm extends React.Component<RestorePasswordFormProps, RestorePasswordFormState> {
  readonly state = {
    emailValue: '',
  }

  handleInputChange = (inputName: keyof RestorePasswordFormState) => (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      [inputName as any]: event.target.value,
    } as RestorePasswordFormState)
  }

  handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const { emailValue } = this.state
    this.props.onSubmit(emailValue)
  }

  goToLogin = () => {
    goToRoute(LOGIN_PATH)
  }

  render() {
    const { classes, loading, authError } = this.props
    const { emailValue } = this.state
    return (
      <>
        <form onSubmit={this.handleSubmit}>
          <Typography className={classes.info} variant="body1">
            Enter your account below so that we can send you an email with the recovery steps
          </Typography>
          <FormControl fullWidth className={classes.formControl}>
            <InputLabel htmlFor="email">Email</InputLabel>
            <Input
              id="email"
              type="email"
              value={emailValue}
              color="secondary"
              disabled={loading}
              onChange={this.handleInputChange('emailValue')}
              autoFocus={!loading}
            />
          </FormControl>
          {authError && (
            <Typography className={classes.errorMessage} variant="caption" color="error">
              The email you entered does not match our records. Please try again.
            </Typography>
          )}
          <div className={classes.submitContainer}>
            <Button color="primary" size="large" onClick={this.goToLogin} disabled={loading}>
              Return to login
            </Button>
            <Button color="secondary" size="large" type="submit" disabled={loading || !emailValue}>
              Send Recovery email
            </Button>
            {loading && <CircularProgress size={24} className={classes.submitProgress} />}
          </div>
        </form>
      </>
    )
  }
}

export type RestorePasswordFormProps = {
  loading: boolean
  authError: boolean
  onSubmit: (email: string) => any
} & WithStyles<typeof styles>

type RestorePasswordFormState = {
  emailValue: string
}

const styles = ({ palette, spacing }: Theme) =>
  createStyles({
    info: {
      marginBottom: spacing(3),
    },
    formControl: {
      marginBottom: spacing(2),
    },
    submitContainer: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      marginTop: spacing(3),
      marginBottom: spacing(),
    },
    submitProgress: {
      color: palette.secondary.main,
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
    errorMessage: {
      marginBottom: spacing(),
    },
  })

export default withStyles(styles)(RestorePasswordForm)
